import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Profile from "../screens/User/Account/Tabs/Profile";
import ModalHeaderFS from "../components/ModalHeaderFS";

type Props = { visible: boolean, onClose: () => void };

const FullSwingProfileModal = (props: Props) => {
  const {visible} = props;

  return (
    <Modal transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ModalHeaderFS title="My Profile" px={20} onCancel={props.onClose}/>

        <ScrollView style={[MainStyle.flex1, {backgroundColor: '#131314'}]} contentContainerStyle={{flexGrow: 1}}>
          <Profile/>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default FullSwingProfileModal;